'use strict';

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _countriesServed = require('./countries-served.dev');

var devData = _interopRequireWildcard(_countriesServed);

var _countriesServed2 = require('./countries-served.prod');

var prodData = _interopRequireWildcard(_countriesServed2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if ((0, _universalConfig2.default)().env === 'development' || (0, _universalConfig2.default)().env === 'local') {
  module.exports = devData;
} else {
  module.exports = prodData;
}